export default __webpack_public_path__ + "74d6d21a1e4dc3bbd2de2753337e7e49.svg";